"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _momentRange = _interopRequireDefault(require("moment-range"));

var _DaysView = _interopRequireDefault(require("./DaysView"));

var _FormError = _interopRequireDefault(require("../forms/FormError"));

var _FormLabel = _interopRequireDefault(require("../forms/FormLabel"));

var _MonthsView = _interopRequireDefault(require("./MonthsView"));

var _YearsView = _interopRequireDefault(require("./YearsView"));

var _Utils = _interopRequireDefault(require("./Utils"));

var _Translator = _interopRequireDefault(require("../../util/i18n/Translator.js"));

var _PopperContainer = _interopRequireDefault(require("../tooltips/PopperContainer"));

var _InputWidths = require("../forms/InputWidths");

var _underscore = require("underscore");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var _keyDownActions = _Utils.default.keyDownActions;
/**
 * @enum {number}
 * @alias Calendar.Views
 * @desc An enum of calendar views.
 */

var Views = {
  DAYS: 0,
  MONTHS: 1,
  YEARS: 2
};
/**
 * @typedef Calendar~dateRange
 * @desc An object describing the start and end dates (inclusive) of a selectable date range.
 *
 * @property {*} [startDate]
 *    The numeric value for the start date of the date range.
 * @property {*} [endDate]
 *    The numeric value for the end date of the date range.
 *
 */

/**
 * @callback Calendar~onValueChange
 *
 * @param {number} date
 *    The numeric value for the selected date.
 */

/**
 * @callback Calendar~onInputTextValueChange
 *
 * @param {number} date
 *    The numeric value for the date typed in the text input field.
 */

/**
 * @class Calendar
 * @desc Calendar renders a basic Calendar popup over an input field. It takes a date number that can be used to set the
 *    current date. Coming from Java backend this should be straight forward. To play with this client side
 *    the moment plugin is helpful to convert a Date object to a numeric value.
 *
 *    Credit: Calendar control taken from https://github.com/Rudeg/react-input-calendar
 *    Compatibility: 0.12.2+ compatible, tested against 0.13.3 and still compatible
 *
 * @param {string} [data-id="calendar"]
 *    To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *    CSS classes to apply to the top-level HTML container.
 * @param {string} [labelClassName]
 *    CSS classes to apply to the label container.
 * @param {HelpHint.Placements} [helpPlacement]
 *     How to place the help hint.
 *
 * @param {*} [date]
 *    Numeric value for the selected date. If not provided, will use the today's date.
 *    When not provided, the component will manage this value.
 * @param {Calendar~dateRange} [dateRange]
 *    A date range to restrict the selectable dates in the calendar.
 *    If provided, will restrict calendar date selection so it can't be less and/or can't be greater than the date range.
 *    An undefined start/end date will result in no restrictions in that direction for the allowable calendar dates.
 * @param {string} [errorMessage]
 *    Text which appears on input field hover as a red error message.
 * @param {string} [format="MM-DD-YYYY"]
 *    String value of the date format you want to display (e.g. "YYYY-MM-DD").
 * @param {string} [computableFormat="MM-DD-YYYY"]
 *    If unsure, leave as "x". Refer to moment#formatTokenFunctions for more info.
 * @param {node} [labelNode]
 *     A FormLabel component that replaces the default label of the calendar.
 * @param {string} [labelHelpText]
 *     The text to display for the help tooltip.
 * @param {string} [labelText]
 *     The text to show as the field's label.
 * @param {string} [label]
 *     Alias for labelText.
 * @param {string} [name]
 *     Name attribute for the input.
 * @param {string} [utcOffset]
 *     When prop is enabled, custom UTC offset value overwrites default browser utc offset.
 *     Format as positive or negative for HH:MM such as +01:50.
 *
 * @param {Calendar.Views} [minView=Calendar.Views.DAYS]
 *    Set the minimal view.
 * @param {Calendar~onValueChange} [onValueChange]
 *    Callback to be triggered when a date is selected.
 * @param {Calendar~onTextInputValueChange} [onTextInputValueChange]
 *    Callback to be triggered when a date is typed into the text input field.
 * @param {Calendar~validateInputValue} [validateInputValue]
 *    Validator function called whenever the value of the Calendar input is changed. Receives
 *    the input's value as an argument; if it returns true, allows the value to be entered. If
 *    false, it does not allow the value to be entered.
 *
 * @param {string} [placeholder]
 *    Placeholder text for the calendar field.
 * @param {boolean} [closeOnSelect=false]
 *    Whether or not the calendar should close once a date is selected.
 * @param {boolean} [required=false]
 *    If true, the user must select a date for the calendar.
 *
 * @example
 *
 *     getInitialState: function () {
 *           return {
 *               selectedDate: moment(new Date()) //current date
 *           };
 *       },
 *
 *     _onEnrollmentDateChanged: function (newValue) {
 *           this.setState({
 *               selectedDate: parseInt(newValue)
 *           });
 *     },
 *
 *     render: function () {
 *             return (
 *                     <Calendar format="YYYY-MM-DD"
 *                          date={this.state.selectedDate}
 *                          computableFormat="x"
 *                          closeOnSelect={true}
 *                          labelText="Start Date"
 *                          onValueChange={this._onEnrollmentDateChanged}/>
 *             );
 *     }
 */

var Calendar = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Calendar, _React$Component);

  var _super = _createSuper(Calendar);

  // runs the date through moment
  function Calendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Calendar);
    _this = _super.call(this, props);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getDate", function (date, utcOffset) {
      // we have a habit of passing back stringified time numbers
      if (date && date.match && date.match(/^\-?[0-9]+$/)) {
        return _this._handleUtcOffset((0, _parseInt2.default)(date), utcOffset);
      }

      return date ? _this._handleUtcOffset(date, utcOffset) : null;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_parseDateRange", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          startDate = _ref.startDate,
          endDate = _ref.endDate;

      return startDate || endDate ? {
        startDate: startDate ? _this._getDate(startDate) : undefined,
        endDate: endDate ? _this._getDate(endDate) : undefined
      } : undefined;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getFormattedDate", function (date) {
      if (date && _this.props.format) {
        return date.format(_this.props.format);
      } else if (date) {
        return date;
      } else {
        return "";
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "keyDown", function (e) {
      e.preventDefault();

      _keyDownActions.call((0, _assertThisInitialized2.default)(_this), e.keyCode);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "nextView", function () {
      _this.setState({
        currentView: _this.state.currentView + 1
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "prevView", function (date) {
      if (_this.state.currentView === _this.props.minView) {
        _this.setState({
          isVisible: false
        });
      } else {
        _this.setState({
          currentView: _this.state.currentView - 1
        });
      }

      var parsedDate = _this._getDate(date);

      if (_Utils.default.inDateRange(parsedDate, _this._parseDateRange(_this.props.dateRange))) {
        _this._handleValueChange(parsedDate);
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "setDate", function (date, isDayView) {
      var parsedDate = _this._getDate(date);

      _this._handleValueChange(parsedDate);

      if (_this.props.closeOnSelect && isDayView) {
        _this.setState({
          isVisible: false
        });
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "changeDate", function (e) {
      var _this$props = _this.props,
          onInputTextValueChange = _this$props.onInputTextValueChange,
          validateInputValue = _this$props.validateInputValue;
      var inputValue = e.target.value; // If there's no validator or if the value is valid, set a new value.

      if (!(0, _underscore.isFunction)(validateInputValue) || validateInputValue(inputValue)) {
        _this.setState({
          inputValue: inputValue
        });

        onInputTextValueChange(inputValue);
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getComputableDate", function (date) {
      return date.format(_this.props.computableFormat);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleValueChange", function (value) {
      var onValueChange = _this.props.onValueChange; // Doing p-stateful implementation here. Because of the computed format change
      // below and the fact that the keyboard interactions use this.state.date,
      // the StateContainer just creates a second source of truth.

      _this.setState(_objectSpread(_objectSpread({}, _this.props.date ? {} : {
        date: value
      }), {}, {
        inputValue: undefined
      }));

      if (onValueChange) {
        onValueChange(_this._getComputableDate(value));
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleUtcOffset", function (date) {
      var convertedDate = (0, _momentRange.default)(date).clone(); // .utcOffset doesn't actually change the date if the argument is undefined,
      // so calling this when there's no utcOffset won't have any effect.

      convertedDate.utcOffset(_this.props.utcOffset, true);
      return convertedDate;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "inputBlur", function () {
      var date = _this.state.inputValue,
          newDate = null,
          format = _this.props.format;

      if (date) {
        // format, with strict parsing true, so we catch bad dates
        newDate = _this._handleUtcOffset((0, _momentRange.default)(date, format, true)); // if the new date didn't match our format, parse it otherwise

        if (!newDate.isValid()) {
          newDate = _this._handleUtcOffset(date);
        }

        if (_Utils.default.inDateRange(newDate, _this._parseDateRange(_this.props.dateRange))) {
          _this._handleValueChange(newDate);
        } else {
          _this.setState({
            inputValue: undefined
          });
        }
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "isCalendar", false);
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "documentClick", function () {
      if (!_this.isCalendar) {
        _this.setVisibility(false);
      }

      _this.isCalendar = false;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "calendarClick", function (e) {
      e.stopPropagation();
      _this.isCalendar = true;
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "toggleClick", function () {
      _this.isCalendar = true;

      _this.setVisibility();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "setVisibility", function (val) {
      var value = val !== undefined ? val : !_this.state.isVisible;
      var eventMethod = value ? "addEventListener" : "removeEventListener";
      document[eventMethod]("keydown", _this.keyDown);

      _this.setState({
        isVisible: value
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "inputClick", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getReference", function () {
      return _this.reference;
    });

    _momentRange.default.locale(_Translator.default.currentLanguage);

    var now = (0, _momentRange.default)();

    if (props.utcOffset) {
      // Change the current time to match the current time in the
      // timezone represented by the UTC offset.
      now.utcOffset(props.utcOffset);
    }

    var _props$initialState = props.initialState,
        initialState = _props$initialState === void 0 ? {} : _props$initialState,
        _props$date = props.date,
        _date = _props$date === void 0 ? initialState.date : _props$date;

    _this.state = {
      date: _this._getDate(_date, props.utcOffset) || now,
      currentView: props.minView,
      isVisible: false
    };
    return _this;
  }

  (0, _createClass2.default)(Calendar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref2) {
      var nextDate = _ref2.date;

      if (this.props.date !== nextDate) {
        this.setState({
          date: this._getDate(nextDate)
        });
      }
    } // formats the date according to the supplied viewing format

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.documentClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.documentClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isVisible === true && this.state.isVisible === false) {
        this.props.onClose(this.state.date);
      }
    }
    /**
     * [keyDown description]
     * @method Calendar#keydown
     * @param  {Object} e The event object
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var parsedDate = this._getDate(this.state.date);

      var calendarDate = parsedDate && parsedDate.isValid() ? parsedDate : this._handleUtcOffset();
      var view;
      var viewProps = {
        date: calendarDate,
        onSetDate: this.setDate,
        onNextView: this.nextView,
        // Run these through getDate so that they're both moment object going into
        // the views and they both have the correct UTC offset, if needed.
        dateRange: this._parseDateRange(this.props.dateRange),
        onPrevView: this.prevView,
        utcOffset: this.props.utcOffset
      };

      switch (this.state.currentView) {
        case Views.DAYS:
          if (calendarDate.locale) {
            calendarDate.locale(_Translator.default.currentLanguage);
          }

          view = /*#__PURE__*/_react.default.createElement(_DaysView.default, viewProps);
          break;

        case Views.MONTHS:
          view = /*#__PURE__*/_react.default.createElement(_MonthsView.default, viewProps);
          break;

        case Views.YEARS:
          view = /*#__PURE__*/_react.default.createElement(_YearsView.default, viewProps);
          break;
      }

      var calendar = /*#__PURE__*/_react.default.createElement("div", {
        className: "input-calendar-wrapper active",
        "data-id": "input-calendar-wrapper",
        onClick: this.calendarClick
      }, view);

      var popup = /*#__PURE__*/_react.default.createElement(_PopperContainer.default, {
        className: "calendar-popup",
        "data-parent": this.props["data-id"],
        getReference: this._getReference,
        placement: "bottom-start",
        ref: function ref(el) {
          return _this2.popperContainer = el;
        },
        noGPUAcceleration: true,
        matchWidth: true
      }, calendar);

      var inputValue = this.state.inputValue === undefined ? this._getFormattedDate(this._getDate(this.state.date)) : this.state.inputValue;
      var date = this.props.date; // This bit of silliness is needed because the required indicator needs to not
      // appear if a user passes in all spaces for a date prop, but we want to make sure
      // that, if date is undefined, everything can still fall through and line 547 still
      // works.

      var trimmedDateProp = date !== undefined && date !== null && (0, _trim.default)(date) ? (0, _trim.default)(date).call(date) : date;
      var className = (0, _classnames.default)("input-calendar", this.props.className, (0, _InputWidths.getInputWidthClass)({
        width: this.props.width
      }), {
        active: this.state.isVisible,
        required: this.props.required,
        "value-entered": trimmedDateProp !== "" && !!(0, _trim.default)(inputValue).call(inputValue),
        "input-calendar--width-tight": this.props.tight,
        "form-error": this.props.errorMessage
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        onClick: this.toggleClick,
        "data-id": this.props["data-id"]
      }, this.props.labelNode || /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        className: (0, _classnames.default)("input-calendar__label", this.props.labelClassName),
        helpClassName: (0, _classnames.default)(this.props.helpClassName),
        helpPlacement: this.props.helpPlacement,
        "data-id": this.props["data-id"] + "-label",
        value: this.props.labelText || this.props.label,
        hint: this.props.labelHelpText
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-container"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "text",
        "data-id": "calendar-input",
        className: "input-calendar-value",
        name: this.props.name // This is weird. Only keeping it around because it causes regressions in one
        // of our demos.
        ,
        value: trimmedDateProp === "" ? "" : inputValue,
        onBlur: this.inputBlur,
        onChange: this.changeDate,
        onClick: this.inputClick,
        placeholder: this.props.placeholder,
        ref: function ref(el) {
          return _this2.reference = el;
        }
      })), this.state.isVisible && popup, this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Icon, {
        "data-id": "calendar-error-message-icon"
      }), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Message, {
        value: this.props.errorMessage,
        "data-id": "calendar-error-message"
      }));
    }
  }]);
  return Calendar;
}(_react.default.Component);

(0, _defineProperty3.default)(Calendar, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  closeOnSelect: _propTypes.default.bool,
  computableFormat: _propTypes.default.string,
  date: _propTypes.default.any,
  dateRange: _propTypes.default.shape({
    startDate: _propTypes.default.any,
    endDate: _propTypes.default.any
  }),
  format: _propTypes.default.string,
  helpClassName: _propTypes.default.string,
  helpPlacement: _propTypes.default.string,
  labelClassName: _propTypes.default.string,
  label: _propTypes.default.string,
  labelNode: _propTypes.default.node,
  labelText: _propTypes.default.string,
  labelHelpText: _propTypes.default.string,
  minView: _propTypes.default.oneOf([Views.DAYS, Views.MONTHS, Views.YEARS]),
  name: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  required: _propTypes.default.bool,
  tight: _propTypes.default.bool,
  width: _propTypes.default.oneOf(_InputWidths.InputWidthProptypesAuto),
  onInputTextValueChange: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  onClose: _propTypes.default.func
});
(0, _defineProperty3.default)(Calendar, "defaultProps", {
  "data-id": "calendar",
  computableFormat: "MM-DD-YYYY",
  closeOnSelect: false,
  minView: Views.DAYS,
  required: false,
  format: _Translator.default.translate("dateformat"),
  onInputTextValueChange: _underscore.noop,
  tight: false,
  width: _InputWidths.InputWidths.AUTO,
  onClose: function onClose() {}
});
Calendar.Views = Views;
Calendar.FormLabel = _FormLabel.default;
Calendar.widths = _InputWidths.InputWidths;
var _default = Calendar;
exports.default = _default;
module.exports = exports["default"];